<template>
  <div class="basicInfo">
    <el-form
      :model="queryParams"
      ref="rulesCompanyInfo"
      :rules="rulesCompanyInfo"
      label-width="120px"
    >
      <!-- <el-form-item label="运营状态：" prop="companyOperationalStatus">
        <el-radio-group v-model="enterpriseInfo.companyOperationalStatus">
          <el-radio
            v-for="(item, index) in query.companyOperationalStatus"
            :key="index"
            :label="item.label"
          ></el-radio>
        </el-radio-group>
      </el-form-item> -->

      <!-- <el-form-item label="企业logo：" prop="companyLogo">
        <upload-image
          :imageUrl.sync="enterpriseInfo.companyLogoLook"
          :saveUrl.sync="enterpriseInfo.companyLogo"
        />
      </el-form-item> -->

      <el-form-item label="企业全称：" prop="companyFullName">
        <el-input
          v-model="queryParams.companyFullName"
          placeholder="请输入"
          style="width: 470px;"
        ></el-input>
      </el-form-item>

      <el-form-item label="企业简称：" prop="companyName">
        <el-input
          v-model="queryParams.companyName"
          placeholder="请输入"
          style="width: 470px;"
        ></el-input>
      </el-form-item>

      <el-form-item label="企业法人：" prop="companyLegalPerson">
        <el-input
          v-model="queryParams.companyLegalPerson"
          placeholder="请输入"
          style="width: 470px;"
        />
      </el-form-item>

      <el-form-item label="法人手机号：" prop="legalRepresentativePhone">
        <el-input
          v-model="queryParams.legalRepresentativePhone"
          placeholder="请输入"
          style="width: 470px;"
        />
      </el-form-item>

      <el-form-item label="经营状态：" prop="companyOperationalStatus">
        <el-radio-group v-model="queryParams.companyOperationalStatus">
          <el-radio
            v-for="(item, index) in companyStatus"
            :key="index"
            :label="item.codeName"
          ></el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="所在地区：">
        <EarthAreaSelect
          :country="queryParams.companyCountry"
          :province="queryParams.companyProvince"
          :city="queryParams.companyCity"
          :region="queryParams.region"
          @searchCountry="searchCountry"
          @searchProvince="searchProvince"
          @searchCity="searchCity"
          @searchArea="searchArea"
        >
        </EarthAreaSelect>
      </el-form-item>

      <el-form-item label="详细地址：" prop="companyAddress">
        <el-input
          v-model="queryParams.companyAddress"
          style="width: 470px"
          type="textarea"
          resize="none"
          rows="2"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="成立时间：">
        <el-date-picker
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="queryParams.companyEstablishTime"
          type="date"
          placeholder="选择日期"
        />
      </el-form-item>

      <el-form-item label="一句话介绍：" prop="companyDescribe">
        <el-input
          type="textarea"
          v-model="queryParams.companyDescribe"
          style="width: 470px"
          resize="none"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="经营范围：" prop="companyScope">
        <el-input
          v-model="queryParams.companyScope"
          style="width: 470px"
          type="textarea"
          resize="none"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="厂房面积：" prop="plantArea">
        <el-input
          v-model="queryParams.plantArea"
          class="lager-input"
          placeholder="请输入"
        />

        <span style="margin-left: 10px">平方米</span>
      </el-form-item>

      <div class="line"></div>

      <el-form-item label="行业类别：" prop="industryLabel">
        <el-input
          v-model="queryParams.industryLabel"
          style="width: 470px"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="所在数智行业：">
        <SelectTreeRadio
          :isTree="true"
          apiName="getIndustryList"
          :params="{ 
            groupLabelType: '赋能行业标签组', 
            level: 4
          }"
          resultType="values"
          storageKey="industryCategoryList"
          v-model="queryParams.industryList"
          :isRadioFirstLevel="false"
          :isCheckBoxButton="false"
        ></SelectTreeRadio>
      </el-form-item>

      <div
        class="each-data"
        v-for="(item, index) in queryParams.szCompanyChainList"
        :key="index"
      >
        <el-form-item
          label="所在产业链编号："
          label-width="128px"
          style="margin-right: 50px;"
        >
          <el-input
            v-model="item.industryChainId"
            style="width: 164px"
            @blur="e => getCompanyIndustryInfo(e, index)"
            placeholder="产业链编号"
          />
        </el-form-item>

        <el-form-item
          label="所在产业链名称："
          label-width="128px"
          style="margin-right: 50px;"
        >
          <el-input
            v-model="item.supplyChainName"
            style="width: 164px"
            :disabled="true"
          />
        </el-form-item>

        <el-form-item
          label="所在产业链位置："
          label-width="128px"
          style="margin-right: 25px;"
        >
          <el-input
            v-model="item.location"
            style="width: 164px"
            :disabled="true"
          />
        </el-form-item>

        <div class="operate-group">
          <span style="color: #4e93fb" @click="addOperateModule()">
            <i class="el-icon-circle-plus-outline"></i>
          </span>

          <span
            v-if="index > 0"
            style="color: #ff7575"
            @click="delOperateModule(index)"
          >
            <i class="el-icon-remove-outline"></i>
          </span>
        </div>
      </div>

      <el-form-item label="产业类型：">
        <el-radio-group v-model="queryParams.industryType">
          <el-radio
            v-for="(item, index) in industryClassify"
            :key="index"
            :label="item.codeName"
          ></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="服务商类型：">
        <el-radio-group v-model="queryParams.serviceProviderType">
          <el-radio
            v-for="(item, index) in serviceClassify"
            :key="index"
            :label="item.codeName"
          ></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="企业简介：" prop="companyBriefIntroduction">
        <el-input
          type="textarea"
          v-model="queryParams.companyBriefIntroduction"
          style="width: 700px"
          rows="11"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="企业详细介绍：" prop="companyDetailedIntro">
        <el-input
          type="textarea"
          v-model="queryParams.companyDetailedIntro"
          style="width: 700px"
          rows="15"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import EarthAreaSelect from "@/components/EarthAreaSelect/index.vue";
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import DicRadioGroup from "@/components/DicRadioGroup.vue";
import UploadImage from "@/components/UploadImage.vue";
import Editorbar from "@/components/Editorbar";
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";

// api
import { getProductType } from "@/api/product";
import {
  selectCompanyIdByLabelId,
  updateBasicInfo,
  getBasicInfo
} from "@/api/enterprise";

import {
  getChainCode
} from "@/api/customCompany.js";

// 企业和产业链的关联 模版数据
const companyConcatTempData = {
  companyId: "", // 公司 ID，用于关联智参企业、服务商企业信息
  industryChainId: "", // 所在产业链编号
  location: "", // 所在产业链位置
  supplyChainName: "" // 所在产业链名称
};

export default {
  name: "BasicInfo",
  components: {
    DicRadioGroup,
    DicCheckboxGroup,
    EarthAreaSelect,
    UploadImage,
    Editorbar,
    SelectTreeRadio
  },
  props: {
    enterpriseInfo: {
      type: Object
    },
    enterpriseType: {
      type: Number
    },
    companyCode: {
      type: String,
      default: ""
    },
    queryParams: {
      type: Object,
      default: () => {
        return new Object()
      }
    }
  },
  watch: {
    enterpriseInfo: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.companyTelephonesArr2 = newVal.companyTelephones;
          this.companyEmailsArr2 = newVal.companyEmails;
        }
      },
      deep: true
    },
    "enterpriseInfo.companyCode": {
      handler(newVal) {
        if (this.enterpriseType && newVal) {
          this.isShow = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isLinkShow: false, //企业链接显示
      isShow: false,
      rulesCompanyInfo: {
        companyLogo: [
          {
            required: true,
            message: "请上传企业logo",
            trigger: "blur"
          }
        ],
        companyFullName: [
          { required: true, message: "请输入企业全称", trigger: "blur" }
        ],
        companyDescribe: [
          { required: true, message: "请输入一句话介绍", trigger: "blur" }
        ]
      },
      list: {
        countrys: [],
        provinces: [],
        citys: []
      },
      companyTelephonesArr1: [],
      companyTelephonesArr2: [""],
      companyEmailsArr1: [],
      companyEmailsArr2: [""],
      isClickAddTel: false,
      isClickAddEmails: false,

      companyStatus: [], //企业经营状态options
      industryClassify: [], //产业类型options
      serviceClassify: [], //服务商类型options
      isInit: false //是否是第一次加载
    };
  },

  async created() {
    // 编辑
    if (!this.enterpriseType) {
      this.isShow = true;
    }
    // 获取企业经营状态
    this.getLableFromDataSystem("companyStatus", "companyStatus", "052");
    // 获取产业类型
    this.getLableFromDataSystem("industryClassify", "industryClassify", "002");
    // 获取服务商类型
    this.getLableFromDataSystem("serviceClassify", "serviceClassify", "001");
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }
      getBasicInfo({ id: this.$route.query.companyCode }).then(
        res => {
          if (res.code == 200) {
            this.isInit = true;
            for (let key in this.queryParams) {
              if(['szCompanyChainList'].includes(key)) {
                if(Array.isArray(res.data[key]) && res.data[key].length) {
                  this.queryParams[key] = res.data[key];
                } else {
                  this.addOperateModule()
                }
              } else {
                this.queryParams[key] = res.data[key];
              }
            }
          }
        }
      );
    },
    submit() {
      this.$modal.loading("正在保存数据，请稍候...");
      updateBasicInfo(this.queryParams)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
    // 从系统字典里获取数据
    async getLableFromDataSystem(storageName, keyName, dataCode) {
      let storageData = sessionStorage.getItem(storageName);

      if (!storageData) {
        try {
          const result = await getProductType({ code: dataCode });

          if (Array.isArray(result.data)) {
            sessionStorage.setItem(storageName, JSON.stringify(result.data));
            this[keyName] = result.data;
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        this[keyName] = JSON.parse(storageData);
      }
    },
    initOperateModule() {
      this.$nextTick(() => {
        this.queryParams.szCompanyChainList.push(
          JSON.parse(JSON.stringify(companyConcatTempData))
        );
      });
    },
    // 企业和产业链的关联
    addOperateModule() {
      this.queryParams.szCompanyChainList.push(
        JSON.parse(JSON.stringify(companyConcatTempData))
      );
    },
    delOperateModule(index) {
      if (Array.isArray(this.queryParams.szCompanyChainList)) {
        this.queryParams.szCompanyChainList.splice(index, 1);
      }
    },
    getCompanyIndustryInfo(e, index) {
      if (e.target.value.trim()) {
        let params = {
          id: e.target.value
        };

        getChainCode(params).then(res => {
          this.queryParams.szCompanyChainList[index].supplyChainName =
            res.data.supplyChainName;
          this.queryParams.szCompanyChainList[index].location =
            res.data.supplyChainIndustry;
        });
      }
    },
    // 企业电话改变
    inputChange() {
      this.$emit("inputChange", this.companyTelephonesArr2);
    },
    // 企业邮箱改变
    inputEmailChange() {
      this.$emit("inputEmailChange", this.companyEmailsArr2);
    },
    searchCountry(val) {
      this.queryParams.companyCountry = val;
    },
    searchProvince(val) {
      this.queryParams.companyProvince = val;
    },
    searchCity(val) {
      this.queryParams.companyCity = val;
    },
    searchArea(val) {
      this.queryParams.region = val;
    },

    updateCode(val, tag) {
      switch (tag) {
        case "领域":
          this.enterpriseInfo.fieldChildrenId = val;
          break;

        case "技术":
          this.enterpriseInfo.techChildrenId = val;
          break;

        default:
          break;
      }
    },
    // 添加企业电话
    addCompanyTelephones() {
      this.isClickAddTel = true;
      let length = this.companyTelephonesArr2.length;
      this.companyTelephonesArr2.push("");
      if (length > 2) {
        this.$message("最多只能添加三条企业电话");
        this.companyTelephonesArr2.pop(length - 1);
      }
    },
    deletEmails(index) {
      this.companyEmailsArr2.splice(index, 1);
    },
    // 添加企业邮箱
    addCompanyEmails() {
      this.isClickAddEmails = true;
      let length = this.companyEmailsArr2.length;
      this.companyEmailsArr2.push("");
      if (length > 2) {
        this.$message("最多只能添加三条企业邮箱");
        this.companyEmailsArr2.pop(length - 1);
      }
    },
    deletTel(index) {
      this.companyTelephonesArr2.splice(index, 1);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-textarea__inner {
  letter-spacing: 2px;
}
/deep/ .el-upload {
  background: #dbdbdb;
}
/deep/ .el-upload--picture-card {
  width: 135px;
  height: 92px;
  line-height: 92px;
  top: 126px;
  left: 157px;
  border-radius: 2px;
  background: rgba(237, 237, 237, 1);
  // border: 2px solid rgba(182, 182, 180, 1)
  border: none;
}
.hide {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
.el-icon-circle-plus {
  font-size: 18px;
  color: rgba(30, 159, 255, 1);
  cursor: pointer;
  margin-left: 4px;
}
/deep/ .el-upload--picture-card {
  width: 135px;
  height: 92px;
  line-height: 92px;
}

/deep/ .el-input__count {
  background-color: transparent;
}

.editorbar_box {
  width: 700px;
  height: 184px;
  border-radius: 4px;
  border: 1px;
  .editBar {
    width: 700px;
    height: 184px;
  }
  .editor {
    .text {
      max-height: 184px !important;
    }
  }
}
/deep/ .el-icon-circle-plus-outline {
  font-size: 31px;
  vertical-align: middle;
  color: #698eef;
  cursor: pointer;
  padding-left: 10px;
}
/deep/ .el-icon-remove-outline {
  font-size: 31px;
  vertical-align: middle;
  color: red;
  cursor: pointer;
  padding-left: 10px;
}

.line {
  margin-bottom: 22px;
  width: 100%;
  border-bottom: 20px solid #d8efff;
}

.each-data {
  display: flex;
  align-items: center;

  .operate-group {
    display: flex;
    align-items: center;
    margin-bottom: 22px;
  }
}
</style>
